// src/components/layout/AppLayout.jsx

import { Outlet } from 'react-router-dom';
import { MobileTopBar } from '../navigation/MobileTopBar';
import { BottomTabBar } from '../navigation/BottomTabBar';
import { Sidebar } from '../navigation/Sidebar';
import { SatisfactionSurveyModal } from '../survey';
import { useState, useEffect } from 'react';

export function AppLayout() {
  const [isStandalone, setIsStandalone] = useState(false);
  useEffect(() => {
    const standalone = window.matchMedia('(display-mode: standalone)').matches
      || window.navigator.standalone;
    setIsStandalone(standalone);
  }, []);
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Desktop Sidebar */}
      <Sidebar />

      {/* Mobile Top Bar */}
      <MobileTopBar />

      {/* Main Content */}
      <div className="lg:pl-64">
        <main
          className="min-h-screen lg:pt-0 lg:pb-0"
          style={{
            paddingTop: isStandalone
              ? 'calc(3.5rem + env(safe-area-inset-top, 0px))'
              : '3.5rem',
            paddingBottom: isStandalone
              ? 'calc(3.5rem + env(safe-area-inset-bottom, 0px))'
              : '3.5rem'
          }}
        >
          <Outlet />
        </main>
      </div>

      {/* Mobile Bottom Tab Bar */}
      <BottomTabBar />

      {/* 30-day satisfaction survey prompt */}
      <SatisfactionSurveyModal />
    </div>
  );
}